"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.user = void 0;
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const effects_1 = require("redux-saga/effects");
const services_1 = __importDefault(require("@/helpers/services"));
const payment_1 = require("@/redux/payment");
const user_1 = require("@/redux/user");
const user = __importStar(require("./user"));
exports.user = user;
function* root() {
    yield (0, effects_1.all)((0, radio_dispatch_1.createNetworkSagas)(services_1.default));
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(user_1.ACTIONS.SET_USER_SESSION, user.authSuccess),
        (0, effects_1.takeLatest)(user_1.ACTIONS.CREATE_USER, user.setCreateUser),
        (0, effects_1.takeLatest)(user_1.ACTIONS.HYDRATE_USER_SUCCESS, user.setUserSession),
        (0, effects_1.takeLatest)(user_1.ACTIONS.HYDRATE_USER_FAILURE, user.logout),
        (0, effects_1.takeLatest)(user_1.ACTIONS.HYDRATE_USER_SUCCESS, user.fetchWallets),
        (0, effects_1.takeLatest)(user_1.ACTIONS.SET_USER_SESSION, user.fetchWallets),
        (0, effects_1.takeLatest)(user_1.ACTIONS.LOGOUT, user.logout),
        (0, effects_1.takeLatest)(user_1.ACTIONS.RESET_PASSWORD_SUCCESS, user.resetPasswordSuccess),
        (0, effects_1.takeLatest)(user_1.ACTIONS.RESET_PASSWORD_CHANGE_SUCCESS, user.resetPasswordChangeSuccess),
        (0, effects_1.takeLatest)(user_1.ACTIONS.ADD_WALLET_ADDRESS, user.fetchNfts),
        (0, effects_1.takeLatest)(payment_1.ACTIONS.CREATE_SUBSCRIPTION_SUCCESS, user.refreshUser),
        (0, effects_1.takeLatest)(payment_1.ACTIONS.CANCEL_SUBSCRIPTION_SUCCESS, user.refreshUser)
    ]);
    yield user.startup();
}
exports.default = root;
